import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import React, { PropsWithChildren } from 'react';

import { CustomTableVariant } from '@/components/table/CustomTable.comp.tsx';
import {
  CustomTableViewWrapperPaperStyles,
  CustomTableViewWrapperStyles,
} from '@/components/table/styles/CustomTable.style.ts';
import { themeColors } from '@/config/theme/themeColors.ts';

type Props = PropsWithChildren & {
  button?: React.ReactNode;
  hidePaper?: boolean;
  isLoading?: boolean;
  size?: CustomTableVariant;
  sx?: SxProps<Theme>;
  sxPaper?: SxProps<Theme>;
};

export const CustomTableViewWrapper: React.FC<Props> = props => {
  const { button, children, hidePaper, isLoading, size, sx, sxPaper } = props;

  const mainStyles = { ...CustomTableViewWrapperStyles, ...(sx ?? {}) };

  if (isLoading) {
    return (
      <Box sx={mainStyles}>
        <PaperWrapper hidePaper={hidePaper ?? false} size={size} sxPaper={sxPaper}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <CircularProgress sx={{ color: themeColors.accentColor, mt: 4 }} />
          </Box>
        </PaperWrapper>
      </Box>
    );
  }

  return (
    <Box sx={mainStyles}>
      <PaperWrapper hidePaper={hidePaper ?? false} size={size} sxPaper={sxPaper}>
        <Box sx={{ textAlign: 'right' }}>{button}</Box>
        <Box>{children}</Box>
      </PaperWrapper>
    </Box>
  );
};

interface PaperWrapperProps extends PropsWithChildren {
  hidePaper: boolean;
  size?: CustomTableVariant;
  sxPaper?: SxProps<Theme>;
}

const PaperWrapper: React.FC<PaperWrapperProps> = ({ children, hidePaper, size, sxPaper }) => {
  const paperStyles = { ...CustomTableViewWrapperPaperStyles({ size }), ...(sxPaper ?? {}) };

  if (hidePaper) {
    return <>{children}</>;
  }

  return (
    <Paper square sx={{ ...paperStyles, borderRadius: 0 }}>
      {children}
    </Paper>
  );
};
